import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * OruClick Logo Component
 * Renders the OruClick icon next to a two-line "OruClick / People" wordmark
 *
 * @param {Object} props
 * @param {number|object} props.iconSize - Size of the icon (default: { xs: "32px", sm: "40px", md: "44px" })
 * @param {number|object} props.titleFontSize - Font size for "OruClick" (default: { xs: "13px", sm: "15px", md: "16px" })
 * @param {number|object} props.subtitleFontSize - Font size for "People" (default: { xs: "18px", sm: "21px", md: "24px" })
 * @param {boolean} props.isDarkTheme - Whether dark theme colors should be used
 * @param {string} props.productName - Text shown under "OruClick" (default: "People")
 */
export const OruClickLogo = ({
  iconSize = { xs: "32px", sm: "40px", md: "44px" },
  titleFontSize = { xs: "13px", sm: "15px", md: "16px" },
  subtitleFontSize = { xs: "18px", sm: "21px", md: "24px" },
  isDarkTheme = false,
  productName = "People",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: "8px", sm: "10px", md: "12px" },
      }}
    >
      <Box
        component="img"
        src="/Logo/OruClickLogo.svg"
        alt="OruClick"
        sx={{
          width: iconSize,
          height: iconSize,
          flexShrink: 0,
        }}
      />
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          sx={{
            fontSize: titleFontSize,
            fontWeight: 500,
            fontFamily: "DM Sans, sans-serif",
            color: isDarkTheme ? "rgba(255,255,255,0.75)" : "#5B6472",
            letterSpacing: "0.2px",
            lineHeight: 1.2,
          }}
        >
          OruClick
        </Typography>
        <Typography
          sx={{
            fontSize: subtitleFontSize,
            fontWeight: 800,
            fontFamily: "DM Sans, sans-serif",
            color: isDarkTheme ? "#fff" : "#1A2233",
            letterSpacing: "-0.3px",
            lineHeight: 1.1,
          }}
        >
          {productName}
        </Typography>
      </Box>
    </Box>
  );
};

export default OruClickLogo;
